(() => {
  const root = document.querySelector('[data-rpg-product-lab]');
  if (!root) return;

  const dialog = root.querySelector('[data-rpg-product-dialog]');
  const content = root.querySelector('[data-rpg-product-dialog-content]');
  const close = root.querySelector('[data-rpg-product-dialog-close]');
  const backToGames = root.querySelector('[data-rpg-back-to-games]');

  const titleRow = root.querySelector('.rpg-product-lab__title-row');
  const productTitle = titleRow?.querySelector('h1');
  const platformBadge = titleRow?.querySelector('.rpg-product-lab__platform-badge');
  const mobileTitleViewport = window.matchMedia('(max-width: 899px)');

  if (titleRow && productTitle) {
    let titleFitFrame;

    const fitMobileProductTitle = () => {
      cancelAnimationFrame(titleFitFrame);
      titleFitFrame = requestAnimationFrame(() => {
        productTitle.style.removeProperty('--rpg-mobile-title-size');
        titleRow.classList.remove('rpg-product-lab__title-row--platform-wrapped');
        titleRow.classList.remove('rpg-product-lab__title-row--two-line-platform-wrapped');

        if (platformBadge) {
          const titleRect = productTitle.getBoundingClientRect();
          const badgeRect = platformBadge.getBoundingClientRect();
          const platformWrapped = badgeRect.top >= titleRect.bottom - 2;
          titleRow.classList.toggle('rpg-product-lab__title-row--platform-wrapped', platformWrapped);
          const titleLineHeight = parseFloat(getComputedStyle(productTitle).lineHeight);
          const titleUsesTwoLines = productTitle.getBoundingClientRect().height > titleLineHeight * 1.5;
          titleRow.classList.toggle(
            'rpg-product-lab__title-row--two-line-platform-wrapped',
            !mobileTitleViewport.matches && platformWrapped && titleUsesTwoLines
          );
        }
      });
    };

    fitMobileProductTitle();
    new ResizeObserver(fitMobileProductTitle).observe(titleRow);
    mobileTitleViewport.addEventListener('change', fitMobileProductTitle);
    document.fonts?.ready.then(fitMobileProductTitle);
  }

  // Liquid's collections.all.products loop only exposes Shopify's current
  // collection window. Look up the base title as well, then retain only cards
  // with this product's exact Game Group ID so every available condition is
  // present even when its sibling falls outside that window.
  const offers = root.querySelector('.rpg-product-lab__offers');
  const offersUrl = root.dataset.rpgOffersUrl;
  const gameGroup = root.dataset.rpgGameGroup;
  const currentProductId = root.dataset.rpgProductId;

  const dealParams = new URLSearchParams(window.location.search);
  const dealDiscountCents = Number(dealParams.get('rpg_dotd_discount'));
  const dealEndsAt = Date.parse(dealParams.get('rpg_dotd_ends') || '');
  const showDiscordDeal = dealParams.get('utm_source') === 'discord'
    && dealParams.get('utm_campaign') === 'discord_deal_of_the_day'
    && Number.isInteger(dealDiscountCents) && dealDiscountCents > 0
    && Number.isFinite(dealEndsAt) && Date.now() < dealEndsAt;
  const storefrontMoney = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
    style: 'currency', currency: window.Shopify?.currency?.active || 'USD'
  });
  const applyDiscordDealPrices = (scope = root) => {
    if (!showDiscordDeal) return;
    scope.querySelectorAll('[data-rpg-offer-price-cents]').forEach((offer) => {
      const regular = offer.querySelector('[data-rpg-regular-price]');
      const deal = offer.querySelector('[data-rpg-deal-price]');
      const discounted = offer.querySelector('[data-rpg-deal-discounted]');
      const priceCents = Number(offer.dataset.rpgOfferPriceCents);
      if (!regular || !deal || !discounted || !Number.isFinite(priceCents)) return;
      discounted.textContent = storefrontMoney.format(Math.max(0, priceCents - dealDiscountCents) / 100);
      regular.hidden = true;
      deal.hidden = false;
      offer.classList.add('rpg-product-offer--deal');
    });
  };
  applyDiscordDealPrices();

  const selectProductOffer = (offer) => {
    if (!offer) return;
    const mediaStage = root.querySelector('.rpg-product-lab__media-stage');
    const artworkShell = mediaStage?.querySelector('.rpg-game-card__artwork-shell');
    const productLayout = root.querySelector('.rpg-product-lab__layout');
    if (!mediaStage || !artworkShell) return;
    offers?.querySelectorAll('[data-rpg-offer-product-id]').forEach((candidate) => {
      const selected = candidate === offer;
      candidate.classList.toggle('rpg-product-offer--current', selected);
      candidate.querySelector('.rpg-product-offer__viewing')?.toggleAttribute('hidden', !selected);
    });
    const animationClass = mobileTitleViewport.matches
      ? 'rpg-product-lab__media-stage--spinning'
      : 'rpg-product-lab__media-stage--desktop-spinning';
    mediaStage.classList.remove('rpg-product-lab__media-stage--spinning', 'rpg-product-lab__media-stage--desktop-spinning');
    void mediaStage.offsetWidth;
    mediaStage.classList.add(animationClass);
    window.setTimeout(() => {
      const showDisc = offer.dataset.rpgOfferDisc === 'true';
      const artworkRatio = Number(productLayout?.dataset.rpgArtworkRatio || 1);
      productLayout?.style.setProperty('--rpg-presentation-ratio', String(showDisc ? 1 : artworkRatio));
      mediaStage.classList.toggle('rpg-product-lab__media-stage--disc', showDisc);
      mediaStage.classList.toggle('rpg-product-lab__media-stage--mobile-tall', !showDisc && artworkRatio < 0.75);
      artworkShell.classList.toggle('rpg-game-card__artwork-shell--disc', showDisc);
      artworkShell.querySelectorAll('.rpg-product-lab__disc-hub').forEach((hub) => hub.remove());
      if (showDisc) {
        ['front', 'back'].forEach((side) => {
          const hub = document.createElement('span');
          hub.className = `rpg-product-lab__disc-hub rpg-product-lab__disc-hub--${side}`;
          hub.setAttribute('aria-hidden', 'true');
          artworkShell.append(hub);
        });
      }
    }, 330);
    window.setTimeout(() => mediaStage.classList.remove(animationClass), 760);
  };

  offers?.addEventListener('click', (event) => {
    if (event.target.closest('button, form')) return;
    selectProductOffer(event.target.closest('[data-rpg-offer-product-id]'));
  });
  offers?.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    if (event.target.closest('button, form')) return;
    event.preventDefault();
    selectProductOffer(event.target.closest('[data-rpg-offer-product-id]'));
  });

  const sortProductOffers = () => {
    if (!offers) return;
    [...offers.querySelectorAll('[data-rpg-offer-product-id]')]
      .sort((first, second) => {
        const rankDifference = Number(first.dataset.rpgOfferRank || 999) - Number(second.dataset.rpgOfferRank || 999);
        if (rankDifference) return rankDifference;
        return Number(first.dataset.rpgOfferProductId || 0) - Number(second.dataset.rpgOfferProductId || 0);
      })
      .forEach((offer) => offers.append(offer));
  };

  sortProductOffers();

  if (offers && offersUrl && gameGroup) {
    fetch(offersUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then((response) => {
        if (!response.ok) throw new Error(`Offer lookup failed (${response.status})`);
        return response.text();
      })
      .then((html) => {
        const documentFragment = new DOMParser().parseFromString(html, 'text/html');
        const seenProductIds = new Set(
          [...offers.querySelectorAll('[data-rpg-offer-product-id]')]
            .map((offer) => offer.dataset.rpgOfferProductId)
        );
        let appendedOfferCount = 0;

        documentFragment.querySelectorAll('[data-rpg-offer-product-id]').forEach((offer) => {
          const offerProductId = offer.dataset.rpgOfferProductId;
          if (
            offer.dataset.rpgOfferGameGroup !== gameGroup ||
            offerProductId === currentProductId ||
            seenProductIds.has(offerProductId)
          ) return;

          seenProductIds.add(offerProductId);
          offers.append(offer);
          appendedOfferCount += 1;
        });

        sortProductOffers();
        applyDiscordDealPrices(offers);

        // A page initially rendered as a disc is only valid when that disc is
        // the sole offer. If a sibling arrives from the lookup, return the hero
        // to its standard case presentation.
        if (appendedOfferCount > 0) {
          const mediaStage = root.querySelector('.rpg-product-lab__media-stage--disc');
          const artworkShell = mediaStage?.querySelector('.rpg-game-card__artwork-shell--disc');
          const productLayout = root.querySelector('.rpg-product-lab__layout');
          const artworkRatio = Number(productLayout?.dataset.rpgArtworkRatio || 1);
          productLayout?.style.setProperty('--rpg-presentation-ratio', String(artworkRatio));
          mediaStage?.classList.remove('rpg-product-lab__media-stage--disc');
          mediaStage?.classList.toggle('rpg-product-lab__media-stage--mobile-tall', artworkRatio < 0.75);
          artworkShell?.classList.remove('rpg-game-card__artwork-shell--disc');
          artworkShell?.querySelectorAll('.rpg-product-lab__disc-hub').forEach((hub) => hub.remove());
        }
      })
      .catch((error) => console.warn('[RPG product offers]', error));
  }

  if (backToGames) {
    backToGames.addEventListener('click', (event) => {
      try {
        const previousUrl = new URL(document.referrer);
        const currentUrl = new URL(window.location.href);
        const isPreviousStorePage = previousUrl.origin === currentUrl.origin;
        const isDifferentPage = previousUrl.pathname !== currentUrl.pathname || previousUrl.search !== currentUrl.search;
        if (isPreviousStorePage && isDifferentPage) {
          event.preventDefault();
          window.history.back();
        }
      } catch (error) {
        // Direct visits use the link's regular all-games fallback.
      }
    });
  }

  root.addEventListener('click', (event) => {
    const qualityReport = event.target.closest('[data-rpg-quality-report]');
    if (qualityReport) {
      const offer = qualityReport.closest('[data-rpg-offer-product-id]');
      const template = offer?.querySelector('[data-rpg-quality-report-content]');
      if (!template) return;
      content.replaceChildren(template.content.cloneNode(true));
      dialog.showModal();
      document.documentElement.classList.add('rpg-dialog-open');
      return;
    }
    const badge = event.target.closest('[data-rpg-product-badge]');
    if (!badge) return;
    const template = root.querySelector(`[data-rpg-product-copy-for="${badge.dataset.rpgProductBadge}"]`);
    if (!template) return;
    content.replaceChildren(template.content.cloneNode(true));
    dialog.showModal();
    document.documentElement.classList.add('rpg-dialog-open');
  });

  close.addEventListener('click', () => dialog.close());
  dialog.addEventListener('close', () => document.documentElement.classList.remove('rpg-dialog-open'));
  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) dialog.close();
  });

  const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
    style: 'currency',
    currency: window.Shopify?.currency?.active || 'USD'
  }).format(Number(cents || 0) / 100);

  let controllerCatalogPromise;
  const availableControllers = async (platform) => {
    controllerCatalogPromise ||= fetch(root.dataset.rpgControllersUrl, {
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
    }).then(async (response) => {
      if (!response.ok) throw new Error('Controller choices could not be loaded.');
      return response.json();
    });
    const payload = await controllerCatalogPromise;
    return (payload.controllers || []).filter((controller) => controller.platform === platform);
  };

  const showConsoleBundlePicker = async (offer) => {
    const platform = offer.dataset.rpgPlatform;
    const controllers = await availableControllers(platform);
    content.replaceChildren();

    const picker = document.createElement('div');
    picker.className = 'rpg-controller-bundle';
    const kicker = document.createElement('p');
    kicker.className = 'rpg-quality-report__kicker';
    kicker.textContent = 'Before You Add It';
    const heading = document.createElement('h2');
    heading.textContent = 'System Only';
    const explanation = document.createElement('p');
    explanation.className = 'rpg-controller-bundle__intro';
    explanation.textContent = 'This console includes the exact pieces and cables shown in its Quality Report. A controller is not included unless it is listed there.';
    const deal = document.createElement('p');
    deal.className = 'rpg-controller-bundle__deal';
    deal.textContent = controllers.length
      ? 'Bundle one available controller for this system and save 20% on that controller.'
      : 'No matching controllers are currently available, but you can still add the system.';
    picker.append(kicker, heading, explanation, deal);

    const choices = document.createElement('div');
    choices.className = 'rpg-controller-bundle__choices';
    controllers.forEach((controller, index) => {
      const label = document.createElement('label');
      label.className = 'rpg-controller-bundle__choice';
      const radio = document.createElement('input');
      radio.type = 'radio';
      radio.name = 'rpg-controller-bundle-choice';
      radio.value = controller.variantId;
      radio.checked = index === 0;
      const image = document.createElement(controller.image ? 'img' : 'span');
      image.className = 'rpg-controller-bundle__image';
      if (controller.image) {
        image.src = controller.image.startsWith('//') ? `https:${controller.image}` : controller.image;
        image.alt = '';
        image.loading = 'lazy';
      } else {
        image.textContent = 'Controller';
      }
      const details = document.createElement('span');
      details.className = 'rpg-controller-bundle__details';
      const name = document.createElement('strong');
      name.textContent = controller.title;
      const meta = document.createElement('span');
      meta.textContent = [controller.grade, controller.contents, controller.functionalStatus].filter(Boolean).join(' · ');
      const prices = document.createElement('span');
      prices.className = 'rpg-controller-bundle__prices';
      const original = document.createElement('s');
      original.textContent = money(controller.price);
      const discounted = document.createElement('strong');
      discounted.textContent = money(Math.round(Number(controller.price) * 0.8));
      prices.append(original, discounted, document.createTextNode(' bundled'));
      details.append(name, meta, prices);
      label.append(radio, image, details);
      choices.append(label);
    });
    picker.append(choices);

    const actions = document.createElement('div');
    actions.className = 'rpg-controller-bundle__actions';
    const systemOnly = document.createElement('button');
    systemOnly.type = 'button';
    systemOnly.className = 'rpg-controller-bundle__skip';
    systemOnly.textContent = 'Add System Only';
    actions.append(systemOnly);
    let bundle;
    if (controllers.length) {
      bundle = document.createElement('button');
      bundle.type = 'button';
      bundle.className = 'rpg-controller-bundle__add';
      bundle.textContent = 'Bundle Controller & Save 20%';
      actions.append(bundle);
    }
    picker.append(actions);
    content.append(picker);
    dialog.classList.add('rpg-product-badge-dialog--bundle');
    dialog.showModal();
    document.documentElement.classList.add('rpg-dialog-open');

    return new Promise((resolve) => {
      let settled = false;
      const finish = (result) => {
        if (settled) return;
        settled = true;
        dialog.classList.remove('rpg-product-badge-dialog--bundle');
        dialog.removeEventListener('close', cancelled);
        if (dialog.open) dialog.close();
        resolve(result);
      };
      const cancelled = () => finish({ action: 'cancel' });
      dialog.addEventListener('close', cancelled, { once: true });
      systemOnly.addEventListener('click', () => finish({ action: 'system-only' }));
      bundle?.addEventListener('click', () => {
        const selected = choices.querySelector('input:checked');
        const controller = controllers.find((candidate) => String(candidate.variantId) === selected?.value);
        if (controller) finish({ action: 'bundle', controller });
      });
    });
  };

  const openCartDrawer = async (button) => {
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.refresh === 'function') {
      await cartDrawer.refresh(true);
      cartDrawer.open(button);
      return;
    }
    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', {
      bubbles: true,
      detail: { opener: button }
    }));
  };

  root.addEventListener('submit', async (event) => {
    const form = event.target.closest('.rpg-product-offer__form');
    if (!form || !root.contains(form)) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const button = form.querySelector('[name="add"]');
    const originalLabel = button ? button.textContent : '';
    if (button && button.getAttribute('aria-disabled') === 'true') return;

    const offer = form.closest('[data-rpg-offer-product-id]');
    let bundleChoice = { action: 'regular' };
    if (offer?.dataset.rpgItemType === 'console') {
      try {
        bundleChoice = await showConsoleBundlePicker(offer);
      } catch (error) {
        bundleChoice = window.confirm(`${error.message || 'Controller choices could not be loaded.'}\n\nAdd the system only?`)
          ? { action: 'system-only' }
          : { action: 'cancel' };
      }
      if (bundleChoice.action === 'cancel') return;
    }

    if (button) {
      button.setAttribute('aria-disabled', 'true');
      button.classList.add('is-loading');
      button.textContent = 'Adding…';
    }

    try {
      const shopRoot = window.Shopify?.routes?.root || '/';
      const variantId = String(new FormData(form).get('id') || '');
      if (!/^\d+$/.test(variantId)) throw new Error('This system could not be identified. Please refresh and try again.');
      const bundleId = bundleChoice.action === 'bundle'
        ? (window.crypto?.randomUUID?.() || `rpg-${Date.now()}`)
        : null;
      const items = [{
        id: variantId,
        quantity: 1,
        properties: offer?.dataset.rpgItemType === 'console' ? {
          '_RPG Sale Format': 'System Only',
          ...(bundleId ? {
            '_RPG Bundle ID': bundleId,
            '_RPG Bundle Role': 'console',
            '_RPG Bundle Platform': offer.dataset.rpgPlatform,
            '_RPG Bundle Discount': '20%'
          } : {})
        } : {}
      }];
      if (bundleChoice.action === 'bundle') {
        items.push({
          id: String(bundleChoice.controller.variantId),
          quantity: 1,
          properties: {
            '_RPG Bundle ID': bundleId,
            '_RPG Bundle Role': 'controller',
            '_RPG Bundle Platform': offer.dataset.rpgPlatform,
            '_RPG Bundle Discount': '20%'
          }
        });
      }
      for (const item of items) {
        const response = await fetch(`${shopRoot}cart/add.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ items: [item] })
        });
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || data.message || 'Unable to add this copy.');
      }

      await openCartDrawer(button);
      document.dispatchEvent(new CustomEvent('on:cart:add', {
        bubbles: true,
        detail: { variantId }
      }));

      if (button) button.textContent = 'Added!';
    } catch (error) {
      if (button) button.textContent = error.message || 'Try again';
    } finally {
      window.setTimeout(() => {
        if (!button) return;
        button.removeAttribute('aria-disabled');
        button.classList.remove('is-loading');
        button.textContent = originalLabel;
      }, 1200);
    }
  }, true);

  const about = root.querySelector('.rpg-product-lab__about');
  const aboutPreview = root.querySelector('[data-rpg-about-preview]');

  if (about && aboutPreview) {
    const aboutScrollBottom = about.querySelector('[data-rpg-about-scroll-bottom]');
    const aboutScrollbar = document.createElement('span');
    const aboutScrollbarThumb = document.createElement('span');
    aboutScrollbar.className = 'rpg-product-lab__about-scrollbar';
    aboutScrollbarThumb.className = 'rpg-product-lab__about-scrollbar-thumb';
    aboutScrollbar.setAttribute('aria-hidden', 'true');
    aboutScrollbar.append(aboutScrollbarThumb);
    about.insertAdjacentElement('afterend', aboutScrollbar);
    let aboutScrollbarIdleTimer;
    let aboutScrollFrame = 0;

    const updateAboutScrollCue = () => {
      const desktop = window.matchMedia('(min-width: 900px)').matches;
      const isScrollable = about.scrollHeight > about.clientHeight + 2;
      const scrollRange = Math.max(0, about.scrollHeight - about.clientHeight);
      const remainingDistance = Math.max(0, scrollRange - about.scrollTop);
      const fadeDistance = Math.max(1, about.clientHeight * 0.1);
      const scrollIndicatorOpacity = isScrollable
        ? Math.max(0, Math.min(1, remainingDistance / fadeDistance))
        : 0;
      about.style.setProperty('--rpg-about-cue-opacity', scrollIndicatorOpacity.toFixed(3));
      about.style.setProperty('--rpg-about-fade-opacity', scrollIndicatorOpacity.toFixed(3));
      about.classList.toggle('rpg-about-is-scrollable', desktop && isScrollable);
      about.classList.toggle('rpg-about-full-has-more', desktop && isScrollable);
      about.classList.toggle('rpg-about-mobile-has-more', !desktop && root.classList.contains('rpg-product-lab--about-expanded') && isScrollable);

      const aboutParent = about.parentElement;
      if (desktop && isScrollable && aboutParent) {
        const trackInset = 8;
        const trackHeight = Math.max(0, about.clientHeight - trackInset * 2);
        const thumbHeight = Math.max(28, trackHeight * (about.clientHeight / about.scrollHeight));
        const thumbTravel = Math.max(0, trackHeight - thumbHeight);
        const progress = scrollRange > 0 ? Math.min(1, about.scrollTop / scrollRange) : 0;
        const aboutStyles = getComputedStyle(about);
        aboutScrollbar.style.setProperty('--rpg-local-scroll-start', aboutStyles.getPropertyValue('--rpg-local-scroll-start'));
        aboutScrollbar.style.setProperty('--rpg-local-scroll-end', aboutStyles.getPropertyValue('--rpg-local-scroll-end'));
        aboutScrollbar.style.top = `${about.offsetTop + trackInset}px`;
        aboutScrollbar.style.left = `${about.offsetLeft + about.offsetWidth - 16}px`;
        aboutScrollbar.style.height = `${trackHeight}px`;
        aboutScrollbarThumb.style.height = `${thumbHeight}px`;
        aboutScrollbarThumb.style.transform = `translateY(${thumbTravel * progress}px)`;
      }
      aboutScrollbar.classList.toggle('is-scrollable', desktop && isScrollable);
      if (!desktop || !isScrollable) aboutScrollbar.classList.remove('is-visible');
    };

    const showAboutScrollbar = () => {
      if (!aboutScrollbar.classList.contains('is-scrollable')) return;
      aboutScrollbar.classList.add('is-visible');
      clearTimeout(aboutScrollbarIdleTimer);
      aboutScrollbarIdleTimer = window.setTimeout(() => {
        aboutScrollbar.classList.remove('is-visible');
      }, 760);
    };

    const queueAboutScrollCue = (showScrollbar = false) => {
      if (aboutScrollFrame) return;
      aboutScrollFrame = requestAnimationFrame(() => {
        aboutScrollFrame = 0;
        updateAboutScrollCue();
        if (showScrollbar) showAboutScrollbar();
      });
    };

    aboutScrollBottom?.addEventListener('click', () => {
      about.scrollTo({ top: about.scrollHeight, behavior: 'auto' });
    });
    about.addEventListener('scroll', () => {
      queueAboutScrollCue(true);
    }, { passive: true });
    new ResizeObserver(() => queueAboutScrollCue()).observe(about);
    new MutationObserver(() => queueAboutScrollCue()).observe(root, { attributes: true, attributeFilter: ['class'] });
    document.fonts?.ready.then(() => queueAboutScrollCue());
    queueAboutScrollCue();
  }

  const mobileAboutToggle = root.querySelector('[data-rpg-mobile-about-toggle]');
  const mobileAboutHint = root.querySelector('[data-rpg-mobile-about-hint]');
  const mobileViewport = window.matchMedia('(max-width: 899px)');

  if (mobileAboutToggle && mobileAboutHint) {
    const mobileAboutControls = mobileAboutToggle.getAttribute('aria-controls');
    const hasArtworkScreenshots = Boolean(mobileAboutToggle.querySelector('[data-rpg-igdb-mobile-slide]'));
    let mobileAboutAnimating = false;

    const setMobileAboutState = (expanded) => {
      root.classList.toggle('rpg-product-lab--about-expanded', expanded);
      mobileAboutToggle.setAttribute('aria-expanded', String(expanded));
      mobileAboutHint.textContent = expanded ? 'Tap Game to Close' : 'Tap Game to Learn More';
    };

    const syncMobileAboutToggle = () => {
      if (mobileViewport.matches) {
        mobileAboutToggle.setAttribute('role', 'button');
        mobileAboutToggle.setAttribute('tabindex', '0');
        mobileAboutToggle.setAttribute('aria-expanded', String(root.classList.contains('rpg-product-lab--about-expanded')));
        if (mobileAboutControls) mobileAboutToggle.setAttribute('aria-controls', mobileAboutControls);
      } else {
        root.classList.remove('rpg-product-lab--about-closing');
        setMobileAboutState(false);
        mobileAboutToggle.classList.remove('rpg-product-lab__media-stage--screenshots-front');
        mobileAboutToggle.removeAttribute('role');
        mobileAboutToggle.removeAttribute('tabindex');
        mobileAboutToggle.removeAttribute('aria-expanded');
        mobileAboutToggle.removeAttribute('aria-controls');
      }
    };

    const toggleMobileAbout = () => {
      if (!mobileViewport.matches || mobileAboutAnimating) return;
      mobileAboutAnimating = true;
      const isExpanded = root.classList.contains('rpg-product-lab--about-expanded');
      mobileAboutToggle.classList.remove('rpg-product-lab__media-stage--spinning');
      void mobileAboutToggle.offsetWidth;
      mobileAboutToggle.classList.add('rpg-product-lab__media-stage--spinning');
      window.setTimeout(() => {
        mobileAboutToggle.classList.toggle('rpg-product-lab__media-stage--disc-hub-hidden', !isExpanded);
      }, isExpanded ? 180 : 500);
      if (isExpanded) {
        root.classList.add('rpg-product-lab--about-closing');
        mobileAboutToggle.setAttribute('aria-expanded', 'false');
        mobileAboutHint.textContent = 'Tap Game to Learn More';
        window.setTimeout(() => {
          mobileAboutToggle.classList.remove('rpg-product-lab__media-stage--screenshots-front');
        }, 360);
        window.setTimeout(() => {
          root.classList.remove('rpg-product-lab--about-expanded', 'rpg-product-lab--about-closing');
        }, 380);
      } else {
        setMobileAboutState(true);
        window.setTimeout(() => {
          mobileAboutToggle.classList.toggle('rpg-product-lab__media-stage--screenshots-front', hasArtworkScreenshots);
        }, 360);
      }
      window.setTimeout(() => {
        mobileAboutToggle.classList.remove('rpg-product-lab__media-stage--spinning');
        mobileAboutAnimating = false;
      }, 720);
    };

    mobileAboutToggle.addEventListener('click', toggleMobileAbout);
    mobileAboutToggle.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      toggleMobileAbout();
    });

    mobileViewport.addEventListener('change', syncMobileAboutToggle);
    syncMobileAboutToggle();

    if (mobileViewport.matches && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      window.setTimeout(() => {
        mobileAboutHint.classList.add('rpg-product-lab__mobile-hint--attention');
        window.setTimeout(() => mobileAboutHint.classList.remove('rpg-product-lab__mobile-hint--attention'), 1500);
      }, 450);
    }
  }

  const mediaStage = root.querySelector('.rpg-product-lab__media-stage');
  const artwork = mediaStage?.querySelector('.rpg-game-card__artwork-shell');
  const screenshotDivider = root.querySelector('.rpg-product-lab__igdb-divider');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const performanceLite = document.documentElement.classList.contains('rpg-performance-lite');

  if (artwork) {
    let artworkEntranceFallback;
    const scheduleArtworkInitialized = () => {
      if (!artwork.classList.contains('rpg-artwork-ready')) return;
      clearTimeout(artworkEntranceFallback);
      artworkEntranceFallback = window.setTimeout(() => artwork.classList.add('rpg-product-lab__artwork-initialized'), 520);
    };
    const finishInitialArtworkEntrance = (event) => {
      if (event.animationName !== 'rpg-artwork-bounce-in') return;
      clearTimeout(artworkEntranceFallback);
      artwork.classList.add('rpg-product-lab__artwork-initialized');
      artwork.removeEventListener('animationend', finishInitialArtworkEntrance);
    };
    artwork.addEventListener('animationend', finishInitialArtworkEntrance);
    if (artwork.classList.contains('rpg-artwork-ready')) {
      scheduleArtworkInitialized();
    } else {
      const artworkReadyObserver = new MutationObserver(() => {
        if (!artwork.classList.contains('rpg-artwork-ready')) return;
        artworkReadyObserver.disconnect();
        scheduleArtworkInitialized();
      });
      artworkReadyObserver.observe(artwork, { attributes: true, attributeFilter: ['class'] });
    }
  }

  if (mediaStage && artwork && !reducedMotion.matches) {
    let frame;
    let touchReset;
    let desktopSpinReset;
    let desktopSpinStart;
    let followFrame;
    let artworkScrollFrame = 0;
    let queuedScrollDelta = 0;
    let followOffset = 0;
    let followVelocity = 0;
    let previousPageScroll = window.scrollY;
    let lastScrollDirection = 0;
    let wasAtLowerBoundary = false;
    let lowerBoundaryLocked = false;
    let bottomBonkArmed = true;
    let bottomBonkTimer;

    const syncBottomBonk = (atLowerBoundary) => {
      if (atLowerBoundary) lowerBoundaryLocked = true;
      if (atLowerBoundary && lastScrollDirection > 0 && !wasAtLowerBoundary && bottomBonkArmed) {
        followVelocity = 0;
        cancelAnimationFrame(followFrame);
        followFrame = 0;
        bottomBonkArmed = false;
        clearTimeout(bottomBonkTimer);
        mediaStage.classList.remove('rpg-product-lab__media-stage--bottom-bonk');
        requestAnimationFrame(() => {
          mediaStage.classList.add('rpg-product-lab__media-stage--bottom-bonk');
          bottomBonkTimer = window.setTimeout(() => {
            mediaStage.classList.remove('rpg-product-lab__media-stage--bottom-bonk');
          }, 650);
        });
      }
      wasAtLowerBoundary = atLowerBoundary;
    };

    const readArtworkGeometry = () => {
      const artworkRect = artwork.getBoundingClientRect();
      const dividerRect = screenshotDivider?.getBoundingClientRect();
      return {
        boundaryTop: dividerRect?.top,
        unshiftedArtworkBottom: artworkRect.bottom - followOffset,
      };
    };

    const renderArtworkFollow = (geometry = readArtworkGeometry()) => {
      if (Number.isFinite(geometry.boundaryTop)) {
        followOffset = Math.min(followOffset, geometry.boundaryTop - geometry.unshiftedArtworkBottom);
      }
      mediaStage.style.translate = `0 ${followOffset.toFixed(2)}px`;
      const atLowerBoundary = Number.isFinite(geometry.boundaryTop)
        && geometry.boundaryTop <= geometry.unshiftedArtworkBottom + followOffset + 0.75;
      syncBottomBonk(atLowerBoundary);
    };

    const settleArtworkFollow = () => {
      if (mobileViewport.matches) {
        followOffset = 0;
        followVelocity = 0;
        mediaStage.style.removeProperty('translate');
        followFrame = 0;
        return;
      }
      if (lowerBoundaryLocked) {
        followVelocity = 0;
        renderArtworkFollow();
        followFrame = 0;
        return;
      }
      // Chase the live scroll movement continuously. These spring values give
      // the artwork roughly 100ms of visual lag plus a small settling overshoot.
      followVelocity += (0 - followOffset) * 0.12;
      followVelocity *= 0.68;
      followOffset += followVelocity;
      renderArtworkFollow();
      if (lowerBoundaryLocked) {
        followVelocity = 0;
        followFrame = 0;
        return;
      }
      if (Math.abs(followOffset) < 0.08 && Math.abs(followVelocity) < 0.08) {
        followOffset = 0;
        followVelocity = 0;
        renderArtworkFollow();
        followFrame = 0;
        return;
      }
      followFrame = requestAnimationFrame(settleArtworkFollow);
    };

    const updateArtworkScroll = (scrollDelta) => {
      if (mobileViewport.matches || !scrollDelta) return;
      lastScrollDirection = Math.sign(scrollDelta);

      /* Products without screenshots have no lower wall. Always release any
         old collision state, and return the artwork to its neutral sticky
         position when the page returns to the top. */
      if (!screenshotDivider) {
        lowerBoundaryLocked = false;
        wasAtLowerBoundary = false;
        bottomBonkArmed = true;
        mediaStage.classList.remove('rpg-product-lab__media-stage--bottom-bonk');
        if (window.scrollY <= 2) {
          followOffset = 0;
          followVelocity = 0;
          cancelAnimationFrame(followFrame);
          followFrame = 0;
          mediaStage.style.removeProperty('translate');
          return;
        }
      }

      if (lastScrollDirection < 0) {
        lowerBoundaryLocked = false;
        bottomBonkArmed = true;
      } else if (lowerBoundaryLocked) {
        followVelocity = 0;
        cancelAnimationFrame(followFrame);
        followFrame = 0;
        renderArtworkFollow();
        return;
      }
      const geometry = readArtworkGeometry();
      if (Number.isFinite(geometry.boundaryTop)
        && geometry.boundaryTop <= geometry.unshiftedArtworkBottom + 0.75) {
        followOffset = geometry.boundaryTop - geometry.unshiftedArtworkBottom;
        followVelocity = 0;
        cancelAnimationFrame(followFrame);
        followFrame = 0;
        renderArtworkFollow(geometry);
        return;
      }
      followOffset = Math.max(-38, Math.min(38, followOffset - scrollDelta));
      followVelocity = 0;
      renderArtworkFollow(geometry);
      if (!followFrame) followFrame = requestAnimationFrame(settleArtworkFollow);
    };

    if (!performanceLite) {
      window.addEventListener('scroll', () => {
        const nextPageScroll = window.scrollY;
        queuedScrollDelta += nextPageScroll - previousPageScroll;
        previousPageScroll = nextPageScroll;
        if (artworkScrollFrame) return;
        artworkScrollFrame = requestAnimationFrame(() => {
          const scrollDelta = queuedScrollDelta;
          queuedScrollDelta = 0;
          artworkScrollFrame = 0;
          updateArtworkScroll(scrollDelta);
        });
      }, { passive: true });

      window.addEventListener('pageshow', () => {
        if (!screenshotDivider && window.scrollY <= 2) {
          followOffset = 0;
          followVelocity = 0;
          lowerBoundaryLocked = false;
          mediaStage.style.removeProperty('translate');
        }
      });
    }

    const setArtworkPosition = (event) => {
      if (mobileViewport.matches) return;
      const bounds = mediaStage.getBoundingClientRect();
      const x = (event.clientX - bounds.left) / bounds.width;
      const y = (event.clientY - bounds.top) / bounds.height;

      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        artwork.style.setProperty('--rpg-tilt-x', `${(x - 0.5) * 4}deg`);
        artwork.style.setProperty('--rpg-tilt-y', `${(0.5 - y) * 4}deg`);
        artwork.style.setProperty('--rpg-shine-x', `${(0.5 - x) * 85}%`);
      });
    };

    const resetArtwork = () => {
      mediaStage.classList.remove('rpg-product-lab__media-stage--touch-active');
      artwork.style.setProperty('--rpg-tilt-x', '0deg');
      artwork.style.setProperty('--rpg-tilt-y', '0deg');
      artwork.style.setProperty('--rpg-shine-x', '0%');
    };

    mediaStage.addEventListener('pointermove', (event) => {
      if (event.pointerType === 'touch') return;
      setArtworkPosition(event);
    });

    mediaStage.addEventListener('pointerdown', (event) => {
      if (event.pointerType !== 'touch' || mobileViewport.matches) return;
      clearTimeout(touchReset);
      mediaStage.classList.add('rpg-product-lab__media-stage--touch-active');
      setArtworkPosition(event);
      touchReset = setTimeout(resetArtwork, 700);
    });

    mediaStage.addEventListener('pointerleave', () => {
      resetArtwork();
    });

    mediaStage.addEventListener('click', () => {
      if (
        mobileViewport.matches ||
        mediaStage.classList.contains('rpg-product-lab__media-stage--desktop-preparing') ||
        mediaStage.classList.contains('rpg-product-lab__media-stage--desktop-spinning')
      ) return;
      clearTimeout(desktopSpinStart);
      clearTimeout(desktopSpinReset);
      const hasArtworkScreenshots = Boolean(mediaStage.querySelector('[data-rpg-igdb-mobile-slide]'));
      const showDesktopScreenshots = hasArtworkScreenshots && !mediaStage.classList.contains('rpg-product-lab__media-stage--screenshots-front');
      mediaStage.classList.add('rpg-product-lab__media-stage--desktop-preparing');
      mediaStage.classList.remove('rpg-product-lab__media-stage--desktop-spinning');
      desktopSpinStart = window.setTimeout(() => {
        mediaStage.classList.remove('rpg-product-lab__media-stage--desktop-preparing');
        void mediaStage.offsetWidth;
        mediaStage.classList.add('rpg-product-lab__media-stage--desktop-spinning');
        window.setTimeout(() => {
          mediaStage.classList.toggle('rpg-product-lab__media-stage--disc-hub-hidden', showDesktopScreenshots);
        }, showDesktopScreenshots ? 500 : 180);
        window.setTimeout(() => {
          mediaStage.classList.toggle('rpg-product-lab__media-stage--screenshots-front', showDesktopScreenshots);
        }, 360);
        desktopSpinReset = window.setTimeout(() => {
          mediaStage.classList.remove('rpg-product-lab__media-stage--desktop-spinning');
          if (mediaStage.matches(':hover')) {
            mediaStage.classList.remove('rpg-product-lab__media-stage--gleam-return');
            void mediaStage.offsetWidth;
            mediaStage.classList.add('rpg-product-lab__media-stage--gleam-return');
            window.setTimeout(() => mediaStage.classList.remove('rpg-product-lab__media-stage--gleam-return'), 360);
          }
        }, 720);
      }, 125);
    });
  }
})();
